import { render } from "./FollowersCount.vue?vue&type=template&id=c0750ef4&ts=true"
import script from "./FollowersCount.vue?vue&type=script&lang=ts"
export * from "./FollowersCount.vue?vue&type=script&lang=ts"

import "./FollowersCount.vue?vue&type=style&index=0&id=c0750ef4&lang=css"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__